export default __webpack_public_path__ + "static/bg-99c15208e6c940540f742a861ad0dc3a.svg";